import { initSubRoutes } from '../../../utils/router';

const RoutesMesTitresDeDetention = initSubRoutes({
    route: '/mes-titres-de-detention',
    subroutes: {},
    nom: 'Mes titres de détention',
});

export default RoutesMesTitresDeDetention;
